import React, { useState, useMemo } from 'react';
import { Fab, withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import * as actions from './store/gpuActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import { Add, Delete, Refresh } from '@material-ui/icons';
import GPUDelete from './GPUDelete'
import { hasPermission, localization, hasAtLeastOnePermission, getDimensionsOfPagination } from '../../sc-utilities';
import MaterialTable from 'material-table'
import Toolbar from '../../sc-utilities/Toolbar'
import { CsvBuilder } from 'filefy';
import { MuiTableRows } from '../../../themes';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginTop: 15,
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    toolbar: {
        paddingTop: '1%'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const GPUList = props => {
    const { classes, editable, translations, handleOpen, saveColumnsFilter, onBulkDeleteGPUs, activeCustomer, permissions, tableColumns, gpus, onFetchGPUs, onFetchGPUsCount, tableRef } = props;

    const [deleteModalState, setDeleteModalState] = useState({ open: false, componentIDs: [] });

    const customExport = (columns, gpuComponentList) => {
        if (columns && columns[0].field === 'Action') {
            columns.shift()
        }
        const data = gpuComponentList.map(gpuComponent => {
            let returnObj = [
                gpuComponent.ComponentType ? gpuComponent.ComponentType : translations['short_not_assigned'] || 'n/a',
                gpuComponent.Vendor ? gpuComponent.Vendor : translations['short_not_assigned'] || 'n/a',
                gpuComponent.ComponentModel ? gpuComponent.ComponentModel : translations['short_not_assigned'] || 'n/a',
                gpuComponent.SerialNumber ? gpuComponent.SerialNumber : translations['short_not_assigned'] || 'n/a',
                gpuComponent.Description ? gpuComponent.Description : translations['short_not_assigned'] || 'n/a',
                gpuComponent.Deleted ? 'Yes' : 'No'
            ];
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_gpu_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('|')
            .setColumns(columns.map(columnDef => columnDef.title))
            .addRows(data)
            .exportFile();
    };

    const handleBulkDelete = componentIDS => {
        if (!componentIDS) {
            setDeleteModalState({ open: false, componentID: null, componentIDs: [], forBulk: false });
            return;
        }
        setDeleteModalState({ ...deleteModalState, open: true, componentIDs: componentIDS, forBulk: true });
    };

    const tableActions = [
        {
            tooltip: `${translations["remove_all_selected"] || "Remove All Selected "} ${translations["gpu"] || "gpu"}`,
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(gpu => gpu.ComponentID)),
            position: 'toolbarOnSelect',
        }
    ]

    const fetching = gpus.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: hasAtLeastOnePermission(permissions, ["component_delete"]),
            search: false,
            minBodyHeight: window.innerHeight - 295 < 250 ? 250 : window.innerHeight - 295,
            maxBodyHeight: window.innerHeight - 295,
            pageSizeOptions: rowsPageSizeInit,

            exportCsv: customExport,
            exportButton: false,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        obj['ComponentType'] = 'GPU';
        obj['ProductID'] = props.productID;
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await onFetchGPUsCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onFetchGPUs(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`GPU`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const handleCloseDanger = async () => {
        await onBulkDeleteGPUs({ ComponentIDs: deleteModalState.componentIDs, ActiveCustomerID: activeCustomer });
        handleBulkDelete();
        tableRef.current && tableRef.current.onQueryChange()
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                <Typography className={classes.typography}>                {translations["gpus"] || "GPUS"}</Typography>
                {hasPermission(permissions, "component_create") ? (
                    <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        disabled={!editable}
                        aria-label="Add"
                        style={{ borderRadius: '1px' }}
                        className={classes.fab}
                        onClick={handleOpen}
                    >
                        <Add size="small" />
                        {translations["create_new"] || "Create new"}
                    </Fab>
                ) : null}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }

    return (<>
        <MaterialTable
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            isLoading={fetching}
            components={{
                Toolbar: props => (
                    <Toolbar data={props} classes={{ toolbar: classes.toolbar }} actions={tableActions} editable={!editable} selectedRows={props.selectedRows} translations={translations} />
                )
            }}
            localization={localization(translations)}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            onChangeColumnHidden={columnHidden}
            actions={tableActions}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {hasPermission(permissions, "component_delete") ? (
            <GPUDelete
                activeCustomer={activeCustomer}
                entityName={translations["gpus"] || "GPUS"}
                translations={translations}
                handleDelete={handleBulkDelete}
                handleCloseDanger={handleCloseDanger}
                deleteModalState={deleteModalState}
            />
        ) : null}

    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchGPUsCount: filter => dispatch(actions.fetchGPUCount(filter)),
        onFetchGPUs: filter => dispatch(actions.fetchGPU(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onBulkDeleteGPUs: nic => dispatch(actions.bulkDeleteGPUs(nic))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        gpus: state.product.gpus,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(GPUList));